import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSidepanelWrapper from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidepanel-wrapper/grossing-touch-sidepanel-wrapper.vue'
import VtBubble from '@/components/common/VtBubble.vue'
import CommonSubportionStatusBadge from '@/components/common/CommonPortionStatusBadge.vue'

@Component({
    components: {
        GrossingTouchSidepanelWrapper,
        VtBubble,
        CommonSubportionStatusBadge
    }
})

export default class GrossingTouchSubportionSidepanel extends Vue {
    private editionMode !: boolean

    constructor() {
        super()
        this.editionMode = false
    }
}
